import { client } from '@/client';
import { CampaignStatusCounts } from '@/client/campaigns';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

const queryKey = 'campaign-status-counts';

export const useCampaignStatusCounts = (
  params: UseQueryOptions & {
    accountId?: string;
  },
): UseQueryResult<CampaignStatusCounts> & {
  campaignStatusCounts: CampaignStatusCounts | undefined;
} => {
  const {
    accountId,
    retry = false,
    retryDelay = 500,
    staleTime = 0,
    cacheTime = 0,
    ...restOptions
  } = params;

  const { data, ...rest } = useQuery(
    [queryKey, accountId],
    () =>
      accountId
        ? client.campaigns.getCampaignStatusCounts(accountId)
        : undefined,
    {
      retry,
      retryDelay,
      staleTime,
      cacheTime,
      ...(restOptions as UseQueryResult<CampaignStatusCounts>),
    },
  );

  return {
    campaignStatusCounts: data,
    ...(rest as UseQueryResult<CampaignStatusCounts>),
  };
};
